import * as Sentry from '@sentry/browser'
import { useEffect } from 'react'
import { appEnv } from 'src/util/appEnv'

/**
 * SentryにuserIdとcompanyIdを設定する
 */
export const useSetSentryUser = (
  userUuid: string | undefined,
  companyId: number | undefined,
) => {
  useEffect(() => {
    if (appEnv.isLocal) return
    if (userUuid) {
      Sentry.setUser({ id: userUuid })
    }
    if (companyId !== undefined) {
      Sentry.setTag('companyId', companyId)
    }
  }, [userUuid, companyId])
}
